import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { Progress, InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import DepartmentHeadPagePresenter from "./DepartmentHeadPagePresenter";
import NavBar from "../../../components/navigation";
import Hierarchy from "../../../components/common/Hierarchy";

class DepartmentHeadPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DepartmentHeadPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
      exporting: false,
    };
  }

  getCollectionName() {
    return "department_head";
  }

  handleViewData(data) {
    this.navigateTo(`/form/${this.getCollectionName()}/${data.id}`);
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit();
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  addEmeForm() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit, exporting } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  Home {">"} Reference Tables {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label || schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row">
                  <Hierarchy
                    className="col-lg-4 mb-2"
                    handleObjectChange={this.presenter.handleHierarchyChange.bind(
                      this,
                    )}
                  />
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary fw-bold">
                      {schema.label || schema.collection}
                    </h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <Button
                        type="button"
                        className="btn btn-light"
                        disabled={exporting}
                        progress={exporting}
                        onClick={() => this.presenter.exportToExcel()}
                      >
                        <i className="bi bi-file-earmark-excel" />{" "}
                        {exporting ? "Exporting..." : "Export to Excel"}
                      </Button>
                      <Button onClick={this.addEmeForm.bind(this)}>
                        <i className="bi bi-plus-lg" /> New{" "}
                        {schema.label || schema.collection}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={(data) => this.presenter.handleDeleteData(data)}
                editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"],
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(DepartmentHeadPage);
